(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "./LiveViewExceedModal", "./LiveViewPanel", "./LiveViewPlayer", "./LocationMap", "./TopRightControl"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("./LiveViewExceedModal"), require("./LiveViewPanel"), require("./LiveViewPlayer"), require("./LocationMap"), require("./TopRightControl"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.LiveViewExceedModal, global.LiveViewPanel, global.LiveViewPlayer, global.LocationMap, global.TopRightControl);
    global.index = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _LiveViewExceedModal, _LiveViewPanel, _LiveViewPlayer, _LocationMap, _TopRightControl) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  Object.keys(_LiveViewExceedModal).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    if (key in _exports && _exports[key] === _LiveViewExceedModal[key]) return;
    Object.defineProperty(_exports, key, {
      enumerable: true,
      get: function get() {
        return _LiveViewExceedModal[key];
      }
    });
  });
  Object.keys(_LiveViewPanel).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    if (key in _exports && _exports[key] === _LiveViewPanel[key]) return;
    Object.defineProperty(_exports, key, {
      enumerable: true,
      get: function get() {
        return _LiveViewPanel[key];
      }
    });
  });
  Object.keys(_LiveViewPlayer).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    if (key in _exports && _exports[key] === _LiveViewPlayer[key]) return;
    Object.defineProperty(_exports, key, {
      enumerable: true,
      get: function get() {
        return _LiveViewPlayer[key];
      }
    });
  });
  Object.keys(_LocationMap).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    if (key in _exports && _exports[key] === _LocationMap[key]) return;
    Object.defineProperty(_exports, key, {
      enumerable: true,
      get: function get() {
        return _LocationMap[key];
      }
    });
  });
  Object.keys(_TopRightControl).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    if (key in _exports && _exports[key] === _TopRightControl[key]) return;
    Object.defineProperty(_exports, key, {
      enumerable: true,
      get: function get() {
        return _TopRightControl[key];
      }
    });
  });
});